import { render, staticRenderFns } from "./DataForm.vue?vue&type=template&id=650b8825&"
import script from "./DataForm.vue?vue&type=script&lang=js&"
export * from "./DataForm.vue?vue&type=script&lang=js&"
import style0 from "./DataForm.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports